import { render, staticRenderFns } from "./OrderPay.vue?vue&type=template&id=53d864cd&scoped=true"
import script from "./OrderPay.vue?vue&type=script&lang=js"
export * from "./OrderPay.vue?vue&type=script&lang=js"
import style0 from "./OrderPay.vue?vue&type=style&index=0&id=53d864cd&prod&scoped=true&lang=less"
import style1 from "./OrderPay.vue?vue&type=style&index=1&id=53d864cd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d864cd",
  null
  
)

export default component.exports